const cookiesStatement = {
  id: 'cookies-statement-lv',
  title: 'Sīkdatņu izmantošanas paziņojumu',
  body: `
  <p>Vietne  business.super-ego.info izmanto sīkdatnes lai uzlabotu un paaugstinātu darbības efektivitāti
  Jūsu, kā lietotāja pieredzi un nodrošinātu noteiktas lietotāja funkcijas,
  kā arī tālab, lai atšķirtu Jūs no citiem lietotājiem izmantojot mūsu vietni
  un citus produktus un pakalpojumus.
  </p>
  <h4>Kas ir sīkdatnes?</h4>
  <p>Sīkdatne - tas ir neliela datne, kura glabājas lokāli tīmekļa pārlūkprogrammā
    vai failu sistēmā jūsu datorā vai mobilajā ierīcē.
    Sīkdatnes izmanto visas tīmekļa vietnes un tām ir vairākas dažādas funkcijas.
    Mēs izmantojam sekojoša tipa sīkdatnes:
  </p>
  <h4>Funkcionālās sīkdatnes</h4>
  <p>Tās ir sīkdatnes, kuras ir vajadzīgas mūsu serveru darbam.
    Tās iekļauj, piemēram, sīkdatnes, kuras ļauj Jums ienākt
    mūsu vietnes drošības zonās un saņemt piekļuvi Super Ego Business informācijai.
  </p>
  <h4>Analītiskās sīkdatnes</h4>
  <p>Šīs sīkdatnes ir svarīgas mūsu vietnei, lai saņemtu statistikas datus, novērtētu auditorijas apmērus, saprastu mūsu vietnes izmantošanu pakalpojumu uzlabošanai, kurus mēs sniedzam mūsu lietotājiem.</p>
  `
}

export default cookiesStatement
